import React, { useEffect } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

/* eslint-disable react/prop-types */
export default function DonutChart({ value, size = null, label = [], font = 20 }) {
  let color;
  if (value >= 100) {
    color = 'green';
  }

  if (value >= 85 && value <= 99) {
    color = 'yellow';
  }

  if (value >= 1 && value <= 84) {
    color = 'red';
  }

  if (parseFloat(value) < 1) {
    color = 'white';
  }

  const dataChart = {
    labels: label,
    datasets: [
      {
        data: [value, value > 100 ? 0 : 100 - value],
        backgroundColor: [color, '#D3D3D3'],
        chartValue: value,
      },
    ],
  };

  const renderChartValue = () => ({
    id: 'textCenter',
    beforeDatasetsDraw(chart) {
      const { ctx, data } = chart;
      const text = data.datasets[0].chartValue;
      ctx.save();
      ctx.font = `bolder ${font}px sans-serif`;
      ctx.fillStyle = 'black';
      ctx.textAlign = 'center';
      ctx.textBaseLine = 'middle';
      ctx.fillText(
        `${text}%`,
        chart.getDatasetMeta(0).data[0].x,
        chart.getDatasetMeta(0).data[0].y,
      );
    },
  });

  useEffect(() => {
    renderChartValue();
  }, []);
  return (
    <div>
      <Doughnut
        data={dataChart}
        plugins={[renderChartValue()]}
        height={size !== null ? `${size}px` : '150px'}
        width={size !== null ? `${size}px` : '150px'}
        options={{ maintainAspectRatio: false }}
      />
    </div>
  );
}
